import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";


export default function Bubble({ role, children, messageType = "text", collapsed = false, onToggle }) {
    const base = role === "user" ? "user-bubble" : "assistant-bubble"; // NOTE: ensure CSS class is spelled correctly
    const extra = messageType === "error" ? "error-bubble" : messageType === "thought" ? "thought-bubble" : "";
    const cls = `${base} ${extra}`.trim();


    return (
        <div className={`flex w-full ${role === "user" ? "justify-end" : "justify-start"}`}>
            <div className={`chatbot-bubbles ${cls}`} onClick={onToggle}>
                {collapsed ? (
                    <span className="italic text-gray-500 cursor-pointer">💭 Pensamientos del LLM - pulsa para ver</span>
                    ) : (
                    children
                )}
            </div>
        </div>
    );
}


export function Markdown({ children }) {
    return <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>;
}
